export default __webpack_public_path__ + "static/media/Shri Akash Tripathi.a9ce8cb2.png";